import { render } from "./ImageryViewMenuSwitcher.vue?vue&type=template&id=e0669124"
import script from "./ImageryViewMenuSwitcher.vue?vue&type=script&lang=js"
export * from "./ImageryViewMenuSwitcher.vue?vue&type=script&lang=js"

import exportComponent from "/builds/stephanik/platform/openmct/base/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__